export const compareValues = (keyName: any, order: 'asc' | 'desc' | undefined = 'asc') => {
  const innerSort = (firstValue: any, secondValue: any) => {
    if (!Object.hasOwn(firstValue, keyName)) return -1;
    if (!Object.hasOwn(secondValue, keyName)) return 1;

    let varA;
    let varB;
    // Assumes the given array is already sorted and only Array field is Security Role.
    if (Array.isArray(firstValue[keyName])) {
      varA = order === 'asc' ? firstValue[keyName][0]?.name || '' : firstValue[keyName][firstValue[keyName].length - 1]?.name || '';
      varB = order === 'asc' ? secondValue[keyName][0]?.name || '' : secondValue[keyName][secondValue[keyName].length - 1]?.name || '';
    } else {
      varA = typeof firstValue[keyName] === 'string' ? firstValue[keyName].toUpperCase().trim() : firstValue[keyName];
      varB = typeof secondValue[keyName] === 'string' ? secondValue[keyName].toUpperCase().trim() : secondValue[keyName];
    }

    let comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }

    return order === 'desc' ? comparison * -1 : comparison;
  };

  return innerSort;
};

export const sortUsersList = (usersList: any[], dataField: string, direction: 'asc' | 'desc') => {
  const newUsers = [...usersList];
  const sortFunction = compareValues(dataField, direction);
  newUsers.sort(sortFunction);
  return newUsers;
};
